'use strict';

window.isMobile = function () {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

function setVariant(prefix, suffix) {
    var variants = $('.product-variant');

    variants.find('li').filter(function () {
        return $(this).attr('data-text') == '' + prefix + suffix;
    }).trigger('click');

    variants.find('li').filter(function () {
        return $(this).attr('data-text') == prefix;
    }).addClass('active');
}

$(document).ready(function () {

    // Carrito
    if ($('#section-cart').length) {
        var PECitems = $('#site-cart-form-page').find('.cart-item').filter(function () {
            return $(this).attr('data-variant').toLowerCase() == "prueba en casa";
        }).length;

        $('.checkout-button').click(function (e) {
            if (PECitems >= 1 && PECitems < 4) {
                e.preventDefault();alert('Debes seleccionar al menos 4 modelos diferentes para la Prueba en casa');
            }
        });
    }
    // end of Carrito


    // Producto
    if ($('.template-product').length) {

        var options = $('#product-options');
        var btnAdd = $('#button-submit');
        var btnNext = $('#button-next');

        // Remover parrafos vacios
        $('p').each(function () {
            var $this = $(this);
            var text = $.trim($this[0].innerText);
            console.log(text);

            if (text == "" || text == " " || text == "&nbsp;") {
                $this.remove();
            }
        });

        // Micas
        $('.option-extra').click(function () {
            var $this = $(this);
            var parent = $this.parent();
            var variants = $('.product-variant');
            var activeVariant = variants.find('.active').attr('data-text');
            var suffix = $this.attr('data-suffix');
            var prefix = void 0;

            if (activeVariant.includes('raduaci')) {
                prefix = "Graduación normal";

                setVariant(prefix, suffix);
            }

            if (activeVariant.includes('rogresivo')) {
                prefix = "Progresivo";

                setVariant(prefix, suffix);
            }

            if (!$this.hasClass('active')) {
                $('.mica').removeClass('active');
                parent.addClass('active');
            }
        });

        $('#button-next').click(function () {

            options.addClass('active');

            $('#button-add').prop('disabled', true).addClass('disabled');

            $(this).add('#description').fadeOut(function () {
                $('#product-options').fadeIn();
            });

            $('input[name="properties[RECETA]"]').change(function (e) {
                e.preventDefault();

                if ($(this).attr('value') == "Por correo") {

                    $('.derecho').add('.izquierdo').add('.dp').fadeOut(function () {
                        $('#receta-mail').fadeIn();
                    });
                }

                if ($(this).attr('value') == "La escribiré ahora") {
                    $('#receta-mail').fadeOut(function () {
                        $('.derecho').add('.izquierdo').add('.dp').fadeIn();
                    });
                }

                if ($(this).attr('value') == "Los quiero sin graduar") {
                    $('.derecho').add('.izquierdo').add('.dp').add('#receta-mail').fadeOut();
                }

                $('#button-add').prop('disabled', false).removeClass('disabled');
            });
        });

        $('.btn-submit').click(function (e) {
            e.preventDefault();

            var receta = $('input[name="properties[RECETA]"]:checked').val();
            var variant = $('.product-variant').find('li.active').attr('data-text');

            if (receta !== "La escribiré ahora") {
                $('.derecho').add('.izquierdo').add('.dp').remove();
            }

            if (variant.includes('rueba en')) {
                $('#product-options').remove();
            }

            $('.shopify-product-form').submit();
        });
    }
    // -------- end od Producto

});

$(window).on('load', function () {
    setTimeout(function () {
        $('#frase-container').fadeOut();
    }, 1000);

    if ($('.template-product').length) {
        var options = $('#product-options');
        var btnAdd = $('#button-submit');
        var btnNext = $('#button-next');

        var variants = $('.product-variant');
        var initialVariant = variants.find('.active').attr("data-text");

        variants.find('li').click(function () {
            var variant = $(this).attr('data-text');

            if (variant.includes("rogresivo") || variant.includes("raduaci")) {
                $('#micas').fadeIn();
            } else {
                $('#micas').fadeOut();
            }

            if (variant.includes('rueba en')) {
                console.log('hey');
                if ($('#product-options').hasClass('active')) {
                    options.fadeOut(0, function () {
                        btnAdd.fadeIn();
                    });
                } else {
                    btnNext.fadeOut(0, function () {
                        btnAdd.fadeIn();
                    });
                }
            } else {
                btnAdd.fadeOut(0, function () {
                    if ($('#product-options').hasClass('active')) {
                        options.fadeIn();
                    } else {
                        btnNext.fadeIn();
                    }
                });
            }

            $('.mica').removeClass('active');
            $('.mica').eq(0).addClass('active');
        });

        if (initialVariant.includes("rogresivo") || initialVariant.includes("raduaci")) {
            $('#micas').fadeIn(0);
        }

        if (initialVariant.includes('rueba en')) {
            btnNext.fadeOut(0, function () {
                btnAdd.fadeIn();
            });
        }
    }
});
"use strict";

var cart = function () {

    var elems = {};

    return {
        entrega: function entrega() {
            $('#checkout').prop('disabled', false);

            $('#entrega_envio').change(function (e) {
                if (this.checked) {
                    $('#form-entrega-envio').fadeIn(400);
                    $('body, html').animate({
                        scrollTop: $('#form-entrega-envio').offset().top - 100
                    }, 1000);

                    $('#checkout').prop('disabled', true);
                }
            });

            $('#entrega_recoger').change(function (e) {
                if (this.checked) {
                    $('#form-entrega-envio').fadeOut(400);

                    $('#form-entrega-envio').find('input').each(function () {
                        $(this).val('');
                    });

                    $('#checkout').prop('disabled', false);
                }
            });
        },

        init: function init() {
            this.entrega();
        }
    };
}();

$(document).ready(function () {
    cart.init();
});

// const cart = (function() {

//     const elems = {
//     };

//     return {
//         sidebar_delete : function() {
//             $('span.cart-item__delete').click(function (e) { 
//                 let variant = $(this).attr('data-id-variant')
//                 jQuery.post('https://zonamexa.mx/cart/change.js', {
//                     quantity: 0,
//                     id: variant
//                 });

//                 jQuery.get('https://zonamexa.mx/cart.js')

//             });
//         },

//         init: function() {
//             this.sidebar_delete();
//         }
//     };

// })();
$(document).ready(function () {
    // cart.init();
});